<template>
    <div class="infinity-scroll">
        <slot name="header" :title="title" :reloadData="reloadData">
            <div class="infinity-scroll--title" v-show="hasTitle">
                {{ title }}
            </div>
        </slot>
        <template v-if="hasItems">
            <div class="infinity-scroll--list" :class="classWrapperList">
                <template v-for="(item, index) in items">
                    <slot name="list" :item="item" :index="index" :total="total">
                        <div class="card" :key="`item-${index}`" :class="classItem">
                            <div class="card-body">
                                {{ item }}
                            </div>
                        </div>
                    </slot>
                </template>
            </div>
            <!-- <slot name="loading" v-if="loading">
                <div class="infinity-scroll--loading">
                    ICONE
                </div>
            </slot> -->
        </template>
        <template v-else-if="!loading">
            <slot name="no-records" >
                <div class="card pt-4">
                    <div class="card-body">
                        <p class="subtitle text-center">{{ noRecords }}</p>
                    </div>
                </div>
            </slot>
        </template>
        <slot name="load-more" v-if="hasNextPage" :loadMore="loadMore">
           <div class="d-flex justify-content-center">
                <button type="buttom" class="btn btn-rounded btn-sm btn-responsive" :class="loadMoreClass" @click.prevent="loadMore" :disabled="loading">
                    <i v-if="loading" class="fas fa-spinner fa-pulse"></i>
                    {{ loadMoreRecords }}
                </button>
           </div>
        </slot>
    </div>
</template>
<script>
import GlobalMixin from '@/app/shared/mixins/global';
import { debounce } from "@config/utils";

export default {
    name: 'infinityScroll',
    mixins: [GlobalMixin],
    props: {
        title: {
            type: String,
            default: '',
        },
        url: {
            required: true,
            type: String
        },
        listenToReload: {
            required: false,
            type: [Array, String],
            default: null
        },
        classItem: {
            required: false,
            type: String,
            default: ''
        },
        classWrapperList: {
            required: false,
            type: String,
            default: '',
        },
        loadMoreRecords: {
            type: String,
            default: 'More',
        },
        loadMoreClass: {
            type: String,
            default: 'btn-block btn-main',
        },
        noRecords: {
            type: String,
            default: 'No records',
        },
        queryParams: {
            type: Object,
            default: () => {},
        },
       
    },
    mounted() {
        this.reloadData();
    },
    created() {
        if(!this.listenToReload) return;
        typeof this.listenToReload == String ? this.events.push(this.listenToReload) : this.events = this.listenToReload;
        this.events.forEach(event => {
            this.$eventBus.listen(this.moduleCode, event, this.reloadData);
        });
    },
    beforeDestroy() {
        this.events.forEach(event => {
            this.$eventBus.remove(this.moduleCode, event, this.reloadData);
        });
    },
    data() {
        return {
            loaded: false,
            loading: false,
            items: [],
            events: [],
            total: 0,
            currentPage: 0,
            lastPage: 0,
        };
    },
    computed: {
        hasNextPage: function() {
            return this.currentPage > 0 && this.lastPage > this.currentPage
        },
        hasItems: function() {
            return this.items.length > 0;
        },
        hasTitle: function() {
            return this.title || !!this.$slots['header']
        }
    },
    methods: {
        reset: function() {
            this.loaded = false;
            this.total = 0;
            this.currentPage = 0;
            this.lastPage = 0;
            this.items = [];
            this.$emit('onReset');
        },
        loadMore: function() {
            this.loadData(false);
        },
        loadData: async function(reset = false) {
            this.loading = true;
            if(reset) this.reset();
            let httpOptions = this.queryParams ? { params: this.queryParams } :null;
            await this.$http.get(`${this.url}?page=${this.currentPage+1}`,httpOptions).then(({data}) => {              
                this.items = [...this.items, ...data.data];
                if(data.meta) {
                    this.currentPage = data.meta.current_page;
                    this.lastPage = data.meta.last_page;
                    this.total = data.meta.total;
                } else {
                    this.total = this.items.length;
                }
                this.loaded = true;
                this.$emit('onLoadData', {...data, total:this.total});
                this.loading = false;

            }).catch(error => {
                this.showHttpError(error);
                this.loading = false;
            });
        },
        reloadData: function() {
            this.loadData(true);
        },
    },
    watch: {
        'queryParams': {
            deep: true,
            handler:debounce( function () {
                this.reloadData();
            }, 1000),
        }
    },
    
}
</script>